import Trainer from "components/classroom/components/backup/Trainer";
import TableElement from "components/classroom/components/TableElement";
import { RootState } from "store";
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Text, Button, Box } from '@radix-ui/themes';
import ImageComponent from "components/classroom/components/ImageComponent";
import expand from "../../../assets/images/expand.png";
import { userInfoMapperSocket } from 'components/containers/utils/sockets/userInfoMapperSocket';
import { socketContextType } from 'index';
import SocketContext from 'socket-context';
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import collapse from "../../../assets/images/collapse.png";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import TableElementNew from "components/classroom/components/TableElementNew";
import { IoExpandOutline } from "react-icons/io5";
import { CiMenuKebab } from "react-icons/ci";
import { Popover } from "@radix-ui/themes";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BsHouseDown } from "react-icons/bs";
import ParticipantGridViewTable from "components/classroom/components/backup/ParticipantGridViewTable";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import ParticipantExpandedTable from "components/classroom/components/backup/ParticipantExpandedTable";
import { updateAudioByTable, updateGdAudioByTable } from "utils/StreamingHelperFunctions";
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';


interface UserData {
    participant_email: string;
    name?: string;
    participant_name?: string;
    id?: string;
    group_leader?: boolean;
    [key: string]: any;
}

interface TableProps {
    onPressExpanded: () => void;
    groupLeaderEmail: any[];
    name: string;
    users: any[];
    roomClient: any;
    handleExpend: (trainee: any[], tableName: string) => void;
}
const Table: React.FC<TableProps> = ({ onPressExpanded, roomClient, groupLeaderEmail, name, users, handleExpend }) => {
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    function groupLeaderEmailFetch(email: string) {
        if (groupLeaderEmail) {
            const groupLeader = groupLeaderEmail
                .flatMap((group) => group.seats)
                .find((seat: UserData) => seat.participant_email === email && seat.group_leader);
            return groupLeader ? groupLeader.participant_email : null;
        }
        return null;
    }

    return (
        <div className="w-full flex flex-col items-center">
            {/* Top Row */}
            <div className="flex flex-row">
                {users && users[2]?.participant_email === 'trainer@vtt' ? (
                    <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                ) : users && users[2]?.participant_email !== undefined ? (
                    <div className="">
                        <div className="rounded-lg">
                            <TableElementNew
                                elementStyle={{
                                    height: '100px',
                                    width: '100px',
                                    borderWidth: 1,
                                    borderRadius: 1,
                                    borderColor: '#D3D3D3',
                                }}
                                isExpandedView={true}
                                onPress={() => console.log('hakuna matata')}
                                userData={users && users[2]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users && users[2].participant_email)}
                            />
                        </div>
                        {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                            {users && users[2]?.name || users && users[2]?.participant_name}
                        </Text> */}
                    </div>
                ) : null}

                {/* {users && users[0] && <div className="px-2"></div>} */}

                {users && users[1]?.participant_email === 'trainer@vtt' ? (
                    <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                ) : users && users[1]?.participant_email !== undefined ? (
                    <div className="">
                        <div className="rounded-lg">
                            <TableElementNew
                                elementStyle={{
                                    height: '100px',
                                    width: '100px',
                                    borderWidth: 1,
                                    borderRadius: 1,
                                    borderColor: '#D3D3D3',
                                    marginVertical: 0.4,
                                }}
                                isExpandedView={true}
                                onPress={() => { }}
                                userData={users && users[1]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users && users[1].participant_email)}
                            />
                        </div>
                        {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                            {users && users[1]?.name || users && users[1]?.participant_name}
                        </Text> */}
                    </div>
                ) : null}
            </div>

            {/* Middle Row */}
            <div className="flex flex-row w-full items-center justify-center">
                {/* Left Side */}
                <div className="flex flex-col gap-1">
                    {users && users[4]?.participant_email === 'trainer@vtt' ? (
                        <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                    ) : users && users[4]?.participant_email !== undefined ? (
                        <div className="flex flex-col gap-1">
                            <div className="rounded-lg">
                                <TableElementNew
                                    elementStyle={{
                                        height: '100px',
                                        width: '100px',
                                        borderWidth: 1,
                                        borderRadius: 1,
                                        borderColor: '#D3D3D3',
                                        marginVertical: 0.4,
                                    }}
                                    isExpandedView={true}
                                    onPress={() => { }}
                                    userData={users && users[4]}
                                    hideKebab={true}
                                    groupLeaderEmail={groupLeaderEmailFetch(users && users[4].participant_email)}
                                />
                                {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                    {users && users[4]?.name || users && users[4]?.participant_name}
                                </Text> */}
                            </div>
                        </div>
                    ) : null}

                    {/* {users && users[0] && <div className="px-2"></div>} */}

                    {users && users[6]?.participant_email === 'trainer@vtt' ? (
                        <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                    ) : users && users[6]?.participant_email !== undefined ? (
                        <div className="flex flex-col gap-1">
                            <div className="rounded-lg">
                                <TableElementNew
                                    elementStyle={{
                                        height: '100px',
                                        width: '100px',
                                        borderWidth: 1,
                                        borderRadius: 1,
                                        borderColor: '#D3D3D3',
                                        marginVertical: 0.4,
                                    }}
                                    isExpandedView={true}
                                    onPress={() => { }}
                                    userData={users && users[6]}
                                    hideKebab={true}
                                    groupLeaderEmail={groupLeaderEmailFetch(users && users[6].participant_email)}
                                />
                                {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                    {users && users[6]?.name || users && users[6]?.participant_name}
                                </Text> */}
                            </div>
                        </div>
                    ) : null}
                </div>

                {/* Table View */}
                {/* <div className="flex relative items-center justify-center bg-[rgba(84,84,85,1)] rounded-[21vw] m-4 h-[15vw] w-[15vw] border border-[rgba(118,118,118,1)]">
                    <div className="bg-[#E9E0FA] h-[15vw] w-[15vw] rounded-[20vw] flex flex-col justify-center items-center border border-[rgba(95,72,138,1)] shadow-md">
                        <div className="flex flex-col items-center justify-center px-8 py-2 bg-[#5f488a] rounded-xl">
                            <Text className="font-[Lato-Bold] text-white text-sm">Case Study</Text>
                            <Text className="font-[Lato-Bold] text-white text-sm">{name}</Text>
                        </div>
                        <Button
                            onClick={() => {
                                onPressExpanded();
                                handleExpend(users, name);
                            }}
                            className="absolute bottom-0 btn flex items-center justify-center bg-[#E9E0FA] hover:bg-[#E9E0FA]"
                        >
                            <ImageComponent
                                source={expand}
                                height={2}
                                width={6}
                                mode="contain"
                            />
                        </Button>
                    </div>
                </div> */}

                <div className="rounded m-2 h-[222px] w-48">

                    <div className="flex flex-col h-full justify-center items-center rounded-full bg-[#24272C] border border-[#302D3F] shadow-[inset_-6px_-6px_12px_rgba(255,255,255,0.25),_6px_6px_12px_rgba(0,0,0,0.25)] ">
                        <div>
                            <div className="bg-[#24272C] text-white py-1 px-4 rounded-lg flex shadow-[inset_-6px_-6px_12px_rgba(255,255,255,0.25),_6px_6px_12px_rgba(0,0,0,0.25)]">
                                {name}
                            </div>
                        </div>
                        <div
                            className="font-bold mt-5 text-xl text-white"
                            onClick={() => {
                                onPressExpanded();
                                handleExpend(users, name);
                            }}
                        >
                            <IoExpandOutline />
                        </div>
                    </div>
                </div>

                {/* Right Side */}
                <div className="flex flex-col gap-1">
                    {users && users[5]?.participant_email === 'trainer@vtt' ? (
                        <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                    ) : users && users[5]?.participant_email !== undefined ? (
                        <div className="">
                            <div className="rounded-lg">
                                <TableElementNew
                                    elementStyle={{
                                        height: '100px',
                                        width: '100px',
                                        borderWidth: 1,
                                        borderRadius: 1,
                                        borderColor: '#D3D3D3',
                                        marginVertical: 0.4,
                                    }}
                                    isExpandedView={true}
                                    onPress={() => { }}
                                    userData={users && users[5]}
                                    hideKebab={true}
                                    groupLeaderEmail={groupLeaderEmailFetch(users && users[5].participant_email)}
                                />
                                {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                    {users && users[5]?.name || users && users[5]?.participant_name}
                                </Text> */}
                            </div>
                        </div>
                    ) : null}

                    {/* {users && users[0] && <div className="px-2"></div>} */}

                    {users && users[7]?.participant_email === 'trainer@vtt' ? (
                        <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                    ) : users && users[7]?.participant_email !== undefined ? (
                        <div className="">
                            <div className="rounded-lg">
                                <TableElementNew
                                    elementStyle={{
                                        height: '100px',
                                        width: '100px',
                                        borderWidth: 1,
                                        borderRadius: 1,
                                        borderColor: '#D3D3D3',
                                        marginVertical: 0.4,
                                    }}
                                    isExpandedView={true}
                                    onPress={() => { }}
                                    userData={users && users[7]}
                                    hideKebab={true}
                                    groupLeaderEmail={groupLeaderEmailFetch(users && users[7].participant_email)}
                                />
                                {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                    {users && users[7]?.name || users && users[7]?.participant_name}
                                </Text> */}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>

            {/* Bottom Row */}
            <div className="flex flex-row items-center">
                {users && users[3]?.participant_email === 'trainer@vtt' ? (
                    <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                ) : users && users[3]?.participant_email !== undefined ? (
                    <div className="">
                        <div className="rounded-lg">
                            <TableElementNew
                                elementStyle={{
                                    height: '100px',
                                    width: '100px',
                                    borderWidth: 1,
                                    borderRadius: 1,
                                    borderColor: '#D3D3D3',
                                    marginVertical: 0.4,
                                }}
                                isExpandedView={true}
                                onPress={() => { }}
                                userData={users && users[3]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users && users[3].participant_email)}
                            />
                            {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                {users && users[3]?.name || users && users[3]?.participant_name}
                            </Text> */}
                        </div>
                    </div>
                ) : null}

                {/* {users && users[0] && <div className="px-2"></div>} */}

                {users && users[0]?.participant_email === 'trainer@vtt' ? (
                    <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                ) : (
                    <div className="">
                        <div className="rounded-lg">
                            <TableElementNew
                                elementStyle={{
                                    height: '100px',
                                    width: '100px',
                                    borderWidth: 1,
                                    borderRadius: 1,
                                    borderColor: '#D3D3D3',
                                    marginVertical: 0.4,
                                }}
                                isExpandedView={true}
                                onPress={() => { }}
                                userData={users && users[0]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users && users[0]?.participant_email)}
                            />
                            {/* <Text className="text-white mt-2 text-center w-[10vh] text-xs">
                                {users && users[0]?.name || users && users[0]?.participant_name}
                            </Text> */}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

interface CSTableProps {
    users?: UserData[];
    name?: string;
    gl?: any;
    tableData: any;
    showExpand?: (v: boolean) => void;
    session?: string;
    roomClient: any;
    isTrainerPresent: any;
}

const CSTable: React.FC<CSTableProps> = ({ users, isTrainerPresent, roomClient, name, gl, tableData, showExpand = () => { }, session }) => {
    const dispatch = useDispatch();
    const [isExpandedView, setIsExpandedView] = useState<boolean>(false);
    const [groupLeaderEmail, setGroupLeaderEmail] = useState<string>('false');
    const [groupLeaderUpdated, setGroupLeaderUpdated] = useState<any>();
    const [participantData, setParticipantsData] = useState<any[]>([]);
    const [expandData, setExpandData] = useState<any[]>([]);

    const userInfoHandler = useRef<UserInfoMapperSocketHandler | null>(null);
    const socketList: socketContextType[] = useContext(SocketContext);

    const consumerPeersIds: any[] = useSelector(
        (state: RootState) => state.live.settings.consumerPeers
    );
    const auth = useSelector((state: RootState) => state.auth.user);
    const myEmail = auth?.email;
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    const [localUsers, setLocalUsers] = useState(users || []);

    useEffect(() => {
        const findPeers = async () => {
            if (localUsers.length > 0 && myEmail) {
                const currentState = roomClient?._store?.getState?.();
                const currentConsumers =
                    currentState?.live?.settings?.consumers || {};

                const currentAudioConsumers = Object.values(currentConsumers).filter(
                    (c: any) =>
                        (c.track?.kind || c.kind) === "audio" &&
                        c.track?.readyState === "live"
                );

                const audioConsumerIds = currentAudioConsumers.map((a: any) => a.peerId);
                console.log('audioConsumerIds: bye', audioConsumerIds);
                const muteStates = updateGdAudioByTable(
                    localUsers,
                    myEmail,
                    "trainer@vtt",
                    audioConsumerIds
                );
                console.log('muteStates: bye', muteStates);
                roomClient.consumerResumeRoleplayersAudio(muteStates.muteStates);
            }
        };
        findPeers();
    }, [consumerPeersIds, localUsers]);

    useEffect(() => {
      if (users && myEmail) {
        const sortedUsers = [...users].sort((a, b) => {
          const aHasUser = a.seats?.some(
            (seat: any) => seat.participant_email === myEmail
          );
          const bHasUser = b.seats?.some(
            (seat: any) => seat.participant_email === myEmail
          );
    
          if (aHasUser && !bHasUser) return -1;
          if (!aHasUser && bHasUser) return 1;
          return 0;
        });
    
        setGroupLeaderUpdated(gl);
        setParticipantsData(isExpandedView ? expandData : sortedUsers);
        dispatch(updateLiveStreamSettings({ groupLeaderNew: gl }));
      } else {
        setGroupLeaderUpdated(gl);
        setParticipantsData(isExpandedView ? expandData : users);
        dispatch(updateLiveStreamSettings({ groupLeaderNew: gl }));
      }
    }, [isExpandedView, gl, users, expandData, myEmail]);

    useEffect(() => {
        console.log('Users updated: bye', users);
        setLocalUsers(users || []);
    }, [users]);

    useEffect(() => {
        if (isTrainerPresent && Object.keys(isTrainerPresent).length > 0) {
            setLocalUsers((prevUsers: any[]) =>
                prevUsers.map((group) => {
                    if (group.table_name === isTrainerPresent.table_name) {
                        const alreadyPresent = group.seats.some(
                            (seat: any) =>
                                seat.participant_email === isTrainerPresent.participant_email
                        );
                        if (alreadyPresent) return group;

                        return {
                            ...group,
                            seats: [...group.seats, isTrainerPresent],
                        };
                    }
                    return group;
                })
            );
        }
        else {
            console.log("Trainer left — removing from all groups");

            setLocalUsers((prevUsers: any[]) =>
                prevUsers.map((group) => ({
                    ...group,
                    seats: group.seats.filter(
                        (seat: any) => seat.participant_email !== "trainer@vtt"
                    ),
                }))
            );
        }
    }, [isTrainerPresent]);

    useEffect(() => {
        if (!userInfoHandler.current && session) {
            userInfoHandler.current = validateAndCreateSocketIfExist(session, handleOnMessage, socketList);
        } else {
            console.log('Found existing callback');
        }
    }, []);

    const handleExpandedClose = () => {
        setExpandData([]);
    };

    const handleOnMessage = async (_data: any) => {
        // Implement socket message handling
    };

    // useEffect(() => {
    //     setGroupLeaderUpdated(gl);
    //     setParticipantsData(isExpandedView ? expandData : tableData);
    // }, [isExpandedView]);

    return (
        <div className="flex-1 w-full h-full">
            {/* Trainer View */}
            {tableData && tableData?.length > 0 ? (
                <div className="flex items-center justify-start">
                    {isExpandedView ? (
                        <div className="flex flex-col items-center w-full">
                            {/* <div className=" rounded-lg border border-white overflow-hidden">
                                <Trainer videoHeight={130} videoWidth={199} name={trainer?.fullname} trainerTableName="On Table 1" />
                            </div> */}
                            {/* <Button
                                onClick={() => {
                                    console.log('CLOSEDDDDDDDDDDDDDDD');
                                    showExpand(true);
                                    setIsExpandedView(false);
                                    handleExpandedClose();
                                }}
                                className="absolute -left-10 top-6 bg-transparent"
                            >
                                <ImageComponent source={collapse} height={3} width={6} mode="contain" />
                            </Button> */}
                            <div className="text-2xl text-white mobile:justify-center flex justify-center m-2 ">
                                <div className="bg-gray-600 p-2 rounded-lg opacity-50">
                                    <AiOutlineFullscreenExit onClick={() => {
                                        console.log('CLOSEDDDDDDDDDDDDDDD');
                                        showExpand(true);
                                        setIsExpandedView(false);
                                        handleExpandedClose();
                                    }} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center">
                            {/* <Button
                                className=" rounded-lg border border-white overflow-hidden mt-3"
                                onClick={() => { }}
                            >
                                 <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                            </Button> */}
                            {/* <div className=" rounded-lg border border-white overflow-hidden">
                                <Trainer videoHeight={130} videoWidth={199} name={trainer?.fullname} trainerTableName="On Table 1" />
                            </div> */}
                            {/* <Text className="text-white text-xs mt-1">{trainer?.fullname}</Text> */}
                        </div>
                    )}
                </div>
            ) : null}

            {/* Case Analysis Ongoing */}
            <div className="relative h-8 flex mobile:flex-col flex-row items-center w-full mt-2 mb-4">
                {/* Center Section - Properly centered with absolute positioning */}
                <div className="absolute left-1/2 -translate-x-1/2 mobile:relative mobile:left-0 mobile:translate-x-0 mobile:order-1 mobile:w-full mobile:flex mobile:justify-center mobile:mb-2">
                    <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-4 gap-4 border border-[#545455] flex flex-row items-center justify-center">
                        <span className="text-[#E9BE50] text-[10px] font-bold">
                           Case Analysis Ongoing
                        </span>
                        <div className="h-[8px] w-[8px] rounded-full bg-[#43A047] border border-[#E9BE50]"></div>
                    </div>
                </div>

                {/* Timer Section */}
                {/* <div className="ml-auto me-4 mobile:ml-0 mobile:me-0 mobile:order-2 mobile:w-full mobile:flex mobile:justify-center">
                    <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                        <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                        <div className="flex flex-row items-center justify-center gap-1">
                            <span className="text-[#E9BE50] text-[10px]">{minutes}m</span>
                            <span className="text-[#E9BE50] text-[10px]">{seconds}s</span>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* Participant Data */}
            {participantData && participantData?.length > 0 ? (
                <div className={`${isExpandedView ? "mt-0" : "mt-10"}"w-full flex flex-col items-center h-full"`}>
                    {!isExpandedView ? (
                        <div className="grid grid-cols-1 gap-2">
                            {participantData.map((v: any, i: number) => (
                                <div key={i} className="w-full flex-1">
                                    <Table
                                        roomClient={roomClient}
                                        users={v?.seats}
                                        onPressExpanded={() => {
                                            showExpand(false);
                                            setIsExpandedView(true);
                                        }}
                                        name={v?.table_name}
                                        groupLeaderEmail={groupLeaderUpdated}
                                        handleExpend={(trainee, tableName) => setExpandData(trainee)}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="w-full h-full flex flex-wrap justify-center">
                            <ParticipantExpandedTable data={participantData} />
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default CSTable;